import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
// import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "../config/app.config";
import { SpinnerService } from "./spinner.service";
import { Router, ActivatedRoute } from "@angular/router";
@Injectable()
export class ApiService {
  ApiUrl = AppConfig.API_ENDPOINT;
  // private headers = new Headers({ 'Accept': '*', 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private router: Router,
    private spinnerService: SpinnerService,
    private toastrService: ToastrService
  ) {}

  // Set headers for all API calls to add security tokens and identifiers
  // retunHeaders() {
  //     const updatedHeader = new Headers(this.headers);
  //     updatedHeader.append('x-access-token', localStorage.getItem('authToken'));
  //     return updatedHeader;
  // }

  // onLogin(params) {
  //     return this.http.post(this.ApiUrl + '/login', params);
  // }

  // signUp(params) {
  //     return this.http.post(this.ApiUrl + '/signup', params);
  // }

  // onGmailLogin(params) {
  //     return this.http.post(this.ApiUrl + '/googleCustomerSignup', params);
  // }

  // getAllModules(params) {
  //     return this.http.post(this.ApiUrl + '/getDefaultModules', params);
  // }

  createEvent(params) {
    return this.http.post(this.ApiUrl + "/addEvent", params);
  }

  // updateEvent(params) {
  //     return this.http.post(this.ApiUrl + '/editEvent', params);
  // }

  // getEventDetail(params) {
  //     return this.http.post(this.ApiUrl + '/getEventById', params);
  // }

  // getAllEvents(params) {
  //     return this.http.post(this.ApiUrl + '/getAllEvent', params);
  // }

  setPremium(params) {
    return this.http.post(this.ApiUrl + "/setPremium", params);
  }
  setFeatured(params) {
    return this.http.post(this.ApiUrl + "/setFeatured", params);
  }
  // getAllOrganisation(params) {
  //     return this.http.post(this.ApiUrl + '/getAllOrganisation', params);
  // }

  // getAllEventsByOrganisation(params) {
  //     return this.http.post(this.ApiUrl + '/getAllEventsByOrganisation', params);
  // }

  // getSpeakerList(params) {
  //     return this.http.post(this.ApiUrl + '/getSpeakerList', params);
  // }

  createProgram(params) {
    return this.http.post(this.ApiUrl + "/addProgram", params);
  }

  // getOneProgram(params) {
  //     return this.http.post(this.ApiUrl + '/getOneProgram', params);
  // }

  editProgram(params) {
    return this.http.post(this.ApiUrl + "/editProgram", params);
  }

  // getAllProgram(params) {
  //     return this.http.post(this.ApiUrl + '/getAllProgram', params);
  // }

  deleteProgram(params) {
    return this.http.post(this.ApiUrl + "/deleteProgram", params);
  }

  createSpeaker(params) {
    return this.http.post(this.ApiUrl + "/createSpeaker", params);
  }

  // getOneSpeaker(params) {
  //     return this.http.post(this.ApiUrl + '/getOneSpeaker', params);
  // }

  editSpeaker(params) {
    return this.http.post(this.ApiUrl + "/editSpeaker", params);
  }

  deleteSpeaker(params) {
    return this.http.post(this.ApiUrl + "/deleteSpeaker", params);
  }

  createPayment(params) {
    return this.http.post(this.ApiUrl + "/setPayment", params);
  }

  verifyPayment(params) {
    return this.http.post(this.ApiUrl + "/verifyPaymentResponse", params);
  }

  httpGetRequests(path) {
    return this.http.get(this.ApiUrl + path);
  }
  httpGetNoRequests(path) {
    return this.http.get(path);
  }
  httpRequests(params, endPoint, showPop): Observable<any> {
    // console.log(params)
    // console.log(endPoint)
    // console.log(showPop)
    return new Observable((observer) => {
      // this.spinnerService.displayLoader(true);
      this.http.post(this.ApiUrl + endPoint, params).subscribe(
        (data: any) => {
          if (data.status == 1) {
            if (showPop == true) {
              this.toastrService.clear();
              // this.spinnerService.displayLoader(false);
              this.toastrService.success("done", "Success");
            }
            // this.spinnerService.displayLoader(false);
            observer.next(data.data);
          } else {
            this.toastrService.clear();
            // this.spinnerService.displayLoader(false);
            this.toastrService.error(data.message, "Error");
          }
        },
        (error) => {
          if (error.status !== 200) {
            if (error.status == 401) {
              // if (error.error == "Unauthorized") {
              //     this.toastrService.clear();
              //     // this.spinnerService.displayLoader(false);
              //     this.toastrService.error("Signing Out", 'Session Timed Out', { timeOut: 8000 });
              //     localStorage.removeItem('token');
              //     this.router.navigate(['/authentication/sign-in']);
              // }
              // if (error.status=="0")
              // {
              //     this.toastrService.clear();
              //     this.spinnerService.displayLoader(false);
              //     console.log("111111111111111111");
              //     this.toastrService.error("Please Try again Later", 'Server Busy', {  timeOut: 10000 });
              // }
            } else {
              if (error.status == "0") {
                // this.toastrService.clear();
                // this.spinnerService.displayLoader(false);
                // console.log("222222222222222");
                this.toastrService.error(
                  "Please Try again Later",
                  "Server Busy",
                  { timeOut: 3000 }
                );
                // this.toastrService.clear();
              } else {
                this.toastrService.clear();
                // this.spinnerService.displayLoader(false);
                this.toastrService.error(error.statusText, "Error");
              }
            }
          } else {
            // if (error.status=="0")
            //     {
            //         this.toastrService.clear();
            //         this.spinnerService.displayLoader(false);
            //         console.log("33333333333");
            //         this.toastrService.error("Please Try again Later", 'Server Busy', {  timeOut: 10000 });
            //     }
            // else
            // {
            this.toastrService.clear();
            // this.spinnerService.displayLoader(false);
            this.toastrService.error(error.statusText, "Error");
            // }
          }
        },
        () => {
          // console.log('Request complete');
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/api.service.ts